import { render, staticRenderFns } from "./materialFolder.vue?vue&type=template&id=32437c9e&"
import script from "./materialFolder.vue?vue&type=script&lang=js&"
export * from "./materialFolder.vue?vue&type=script&lang=js&"
import style0 from "./materialFolder.vue?vue&type=style&index=0&id=32437c9e&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports